import { render, staticRenderFns } from "./tutor-apply-list.vue?vue&type=template&id=28f27991&scoped=true&"
import script from "./tutor-apply-list.vue?vue&type=script&lang=js&"
export * from "./tutor-apply-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f27991",
  null
  
)

export default component.exports